module.exports = __webpack_public_path__ + "img/add_credit_tab.0995d32a.svg";